import URL from '../helper';
import axiosCall from './interceptor';

export const getLdapUsers = async () => {
  const url = `${URL.BASE_URL}ldapuser`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const addLdapUsers = async data => {
  const url = `${URL.BASE_URL}user`;
  let response = await axiosCall('post', url, data);
  return response.data;
};

export const getLdapConfigs = async () => {
  const url = `${URL.BASE_URL}settings/ldap`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const updateLdapConfigs = async data => {
  const url = `${URL.BASE_URL}settings/ldap`;
  let response = await axiosCall('post', url, data);
  return response.data;
};
